import { FC } from 'react'
import Image from 'next/image'

const LogoMap: Record<
  string,
  {
    alt: string
    path: string
    size: {
      width: number
      height: number
    }
  }
> = {
  rydershare: {
    alt: 'Rydershare Logo',
    path: '/images/RydershareLogo.svg',
    size: {
      width: 132,
      height: 19,
    },
  },
  loadBoard: {
    alt: 'Load Board Logo',
    path: '/images/LoadBoardLogo.svg',
    size: {
      width: 190,
      height: 22,
    },
  },
  driverVisibility: {
    alt: 'Driver Visibility Logo',
    path: '/images/DriverVisibilityLogo.svg',
    size: {
      width: 223,
      height: 22,
    },
  },
  shipments: {
    alt: 'Rydershare Logo',
    path: '/images/RydershareLogo.svg',
    size: {
      width: 132,
      height: 19,
    },
  },
  dataManagement: {
    alt: 'Data Management Logo',
    path: '/images/DataManagementLogo.svg',
    size: {
      width: 135,
      height: 22,
    },
  },
  planningBoard: {
    alt: 'Planning Board Logo',
    path: '/images/PlanningBoardLogo.svg',
    size: {
      width: 259,
      height: 22,
    },
  },
  homeLogo: {
    alt: 'Home Logo',
    path: '/images/HomeLogo.svg',
    size: {
      width: 219,
      height: 22,
    },
  },
  loadEntry: {
    alt: 'Load Entry Logo',
    path: '/images/LoadEntry.svg',
    size: {
      width: 219,
      height: 22,
    },
  },
  activeLoads: {
    alt: 'Active Loads Logo',
    path: '/images/ActiveLoads.svg',
    size: {
      width: 219,
      height: 22,
    },
  },
  activeExceptions: {
    alt: 'Active Exceptions Logo',
    path: '/images/ActiveExceptions.svg',
    size: {
      width: 260,
      height: 22,
    },
  },
  signOff: {
    alt: 'Sign OffLogo',
    path: '/images/SignOff.svg',
    size: {
      width: 219,
      height: 22,
    },
  },
  efficiencyManagement: {
    alt: 'Efficiency Management Logo',
    path: '/images/EfficiencyManagementLogo.svg',
    size: {
      width: 300,
      height: 22,
    },
  },
}

type Props = {
  imgName: string
}

const DynamicLogo: FC<Props> = ({ imgName }) => {
  const image = LogoMap[imgName]

  return <Image alt={image.alt} src={image.path} {...image.size} />
}

export default DynamicLogo
